import { render, staticRenderFns } from "./discount-codes.vue?vue&type=template&id=032ed8c8"
import script from "./discount-codes.vue?vue&type=script&lang=js"
export * from "./discount-codes.vue?vue&type=script&lang=js"
import style0 from "./discount-codes.vue?vue&type=style&index=0&id=032ed8c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports